import MatestackUiVueJs from "matestack-ui-vuejs";

const styledCounter = {
  mixins: [MatestackUiVueJs.componentMixin, MatestackUiVueJs.formInputMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,

  data() {
    return {
      quantity: 1,
      step: 1,
      min: 1,
    }
  },
  methods: {
    add: function() {
      const self = this

      self.quantity += self.step

      self.notifyQuantityUpdate();
    },
    subtract: function() {
      const self = this

      if (self.min === self.quantity) {
        return
      }

      self.quantity -= self.step

      self.notifyQuantityUpdate();
    },

    notifyQuantityUpdate: function() {
      const self = this

      MatestackUiVueJs.eventHub.$emit("quantity-modified", {quantity: self.quantity}) 
    },

    preventValidationSkips: function() {
      const self = this

      if (self.quantity < self.min) {
        self.quantity = self.min
      }

      self.notifyQuantityUpdate();
    }
  },
  mounted() {
  },
  watch: {
    quantity: function() {
      this.setValue(this.quantity);
    }
  }
}

export default styledCounter